import React, { useEffect, useState } from 'react';
import {
  Pagination,
  Modal,
  Table,
  Popconfirm,
  Row,
  Col,
  Typography,
  DatePicker,
  Descriptions,
  Badge,
  Button,
  message,
  Collapse,
  Form,
  Input,
  Divider
} from 'antd';
import './bandeja.css';
import api from '../../../../services/saludProvider';
import Moment from 'react-moment';
import saludProvider from '../../../../services/saludProvider';
import { navegarAFicha } from '../../../../utils/navegar-ficha';
import {
  DownloadOutlined,
  ExclamationCircleOutlined,
  FilePdfOutlined,
  FrownOutlined,
  SearchOutlined,
  SmileOutlined,
  LoadingOutlined,
  SyncOutlined
} from '@ant-design/icons';
import jwt_decode from 'jwt-decode';

// import { StyleSheet, PDFDownloadLink, Font,PDFViewer } from '@react-pdf/renderer';
import FichaPreview from '../../pdf/fichaPreview';
import administracionProvider from '../../../../services/administracionProvider';
import locale from 'antd/es/date-picker/locale/es_ES';
import reportesProvider from '../../../../services/reportesProvider';
import { saveAs } from 'file-saver';
import moment from 'moment';

const { Text } = Typography;
const { Panel } = Collapse;
const { RangePicker } = DatePicker;

const pageSize = 5;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
  return <Pagination onChange={onChange} total={total} current={current} pageSize={pageSize} />;
};
// Font.register({
//   family: 'Oswald',
//   src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
// });

interface Filtro {
  Nombre: string;
  FechaIni: Moment;
  FechaFin: Moment;
}

const TablaCovid19 = () => {
  const token: any = jwt_decode(localStorage.getItem('token'));
  const usr: any = JSON.parse(token.data);
  const [current, setCurrent] = useState(1);
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [usuario, setUsuario] = useState(usr);
  const [filtroActivo, setfiltroactivo] = useState('0');
  const [exportando, setexportando] = useState(false);
  const [ficha, setficha] = useState({
    cercaniaCovid: false,
    codigo: '',
    criticidad: null,
    cuarentenax: null,
    descansox: null,
    direccion: '',
    dni: '',
    empresaId: 0,
    enfermedadesRelacionadas: '',
    estado: '',
    estadoId: 0,
    fechaCalificacion: null,
    fechaMod: null,
    fechaReg: '',
    fiebre: false,
    flema: false,
    flemaTipo: null,
    gustoPerdida: false,
    olfatoPerdida: false,
    gustoPerdidaNivel: 0,
    id: 0,
    key: 0,
    medicacion: false,
    medicacionDescripcion: '',
    medicoId: null,
    nombreApellido: '',
    nombreNivelGusto: '',
    nombreTemperatura: '',
    nombreTipoExpectoracion: null,
    observaciones: null,
    peso: null,
    referencia: '',
    requiereEvaluacion: false,
    restriccionAcceso: null,
    tag: null,
    telefono: '',
    telefonoReferencia: '',
    temperatura: 0,
    terminos: false,
    tosSeca: false,
    usuarioRegistra: 0
  });
  const [filtro, setfiltro] = useState<Filtro>();

  const [cargando, setcargando] = useState(false);

  const coloresEstados = (val) => {
    if (val.estadoId == 1) return 'blue';
    if (val.estadoId == 2) return '#e9e165';
    if (val.estadoId == 7) return '#d952de';
    return '';
  };

  const descargar = async (val) => {
    const adj: any = await administracionProvider.obtenerAdjuntoModel(val.id);
    const response = await administracionProvider.obtenerAdjunto(val.id);
    saveAs(response, adj.archivoOriginal);
  };

  const mostrarInformacion = (data) => {
    Modal.info({
      title: 'Ficha (' + data.codigo + ')',
      width: 1000,
      content: (
        <>
          <Descriptions bordered>
            <Descriptions.Item label='Apellidos y Nombres'>{data.nombreApellido}</Descriptions.Item>
            <Descriptions.Item label='Dirección'>{data.direccion}</Descriptions.Item>
            <Descriptions.Item label='DNI'>{data.dni}</Descriptions.Item>
            <Descriptions.Item label='Fecha Registro'>
              <Moment format={'LLL'}>{data.fechaReg}</Moment>
            </Descriptions.Item>
            <Descriptions.Item label='Fecha de Revisión' span={2}>
              {data.fechaMod}
            </Descriptions.Item>
            <Descriptions.Item label='Estado'>
              <Badge status='processing' color={coloresEstados(data)} text={data.estado} />
            </Descriptions.Item>
            <Descriptions.Item label='Acceso?' span={2}>
              {data.estadoId === 1 || data.estadoId === 5 ? (
                <SmileOutlined style={{ color: '#27AE60' }} />
              ) : (
                <FrownOutlined style={{ color: '#E74C3C' }} />
              )}
            </Descriptions.Item>
            <Descriptions.Item label='Prueba Covid19'>
              {data.adjuntos.length > 0 ? (
                <Button type={'link'} onClick={() => descargar(data.adjuntos[0])}>
                  {data.adjuntos[0].archivoOriginal}
                </Button>
              ) : null}
            </Descriptions.Item>
            <Descriptions.Item label='Acepto terminos' span={2}>
              {data.terminos && <i className='icofont-check-alt'></i>}
            </Descriptions.Item>
            <Descriptions.Item label='Cuestionario'>
              ¿Haz tenido alguno de estos síntomas en los últimos 14 dias?
              <br />
              Sensación de alza térmica, fiebre o malestar.{' '}
              <Text type={'warning'}>
                {data.fiebre ? 'Si' : 'No'}, {data.nombreTemperatura}
              </Text>
              <br />
              Dolor de garganta, tos, estornudos o dificultad para respirar.{' '}
              <Text type={'warning'}>{data.tosSeca ? 'Si' : 'No'}</Text>
              <br />
              Dolor de cabeza, diarrea o congestión nasal.{' '}
              <Text type={'warning'}>{data.dolorCabezaDiarrea ? 'Si' : 'No'}</Text>
              <br />
              Pérdida del gusto y/o del olfato.{' '}
              <Text type={'warning'}>
                {data.gustoPerdida ? 'Si' : 'No'}, {data.nombreNivelGusto}
              </Text>
              <br />
              {/* Pérdida del olfato. <Text type={'warning'}>{data.olfatoPerdida ? 'Si' : 'No'}</Text>
              <br /> */}
              {/* Expectoración de flema. <Text type={'warning'}>{data.flema ? 'Si' : 'No'}, {data.nombreTipoExpectoracion}</Text>
              <br /> */}
              ¿Contacto con un caso confirmado de COVID-19?
              <br />
              <Text type={'warning'}>{data.cercaniaCovid ? 'Si' : 'No'}</Text>
              <br />
              ¿Pertenece a algún Grupo de Riesgo para COVID-19 ?
              <br />
              <Text type={'warning'}>{data.perteneceGrupoRiesgoCovid ? 'Si' : 'No'}</Text>
              <br />
              ¿Está tomando alguna medicación (detallar cuál o cuáles)?
              <br />
              <Text type={'warning'}>
                {data.medicacion ? 'Si' : 'No'}, {data.medicacionDescripcion}
              </Text>
            </Descriptions.Item>
          </Descriptions>
        </>
      ),
      onOk() {}
    });
  };

  const habilitarBontonIr = () => {
    return !usuario.MostrarBotonIr;
  };

  const columns = [
    {
      title: 'Codigo',
      dataIndex: 'codigo',
      render: (text, row, index) => {
        return <Text underline>{text}</Text>;
      }
    },
    {
      title: 'Apellidos y Nombres',
      dataIndex: 'nombreapellido'
    },
    {
      title: 'Fecha. Reg',
      dataIndex: 'fechaReg',
      render: (text, row, index) => {
        return <Moment format={'LLL'}>{text}</Moment>;
      }
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      render: (text, row, index) => {
        if (row.estadoId == 1) return <Text style={{ color: '#1890ff' }}>{text}</Text>;
        if (row.estadoId == 2 && usuario.MostrarBotonIr)
          return (
            <Badge count={<ExclamationCircleOutlined style={{ color: 'red' }} />}>
              <Text style={{ color: 'red' }}>{text}</Text>
            </Badge>
          );
        if (row.estadoId == 2 && !usuario.MostrarBotonIr)
          return <Text type={'warning'}>{text}</Text>;
        if (row.estadoId == 3) return <Text style={{ color: '#d102e7' }}>{text}</Text>;
        if (row.estadoId == 4) return <Text style={{ color: '#b7b7b7' }}>{text}</Text>;
        if (row.estadoId == 7) return <Text style={{ color: '#ffe103' }}>{text}</Text>;
        else return <Text>{text}</Text>;
      }
    },
    {
      title: 'Acciones',
      dataIndex: 'operation',
      render: (text, row, index) =>
        data.data.length >= 1 ? (
          <>
            <Popconfirm
              title='Que desea hacer?'
              okButtonProps={{ disabled: habilitarBontonIr() }}
              okText='Abrir'
              cancelText='Vista rapida'
              onCancel={() => vistaRapida(row)}
              onConfirm={() => abrirFicha(row)}
            >
              <a onClick={(e) => e.preventDefault()} href='#'>
                Opción
              </a>
            </Popconfirm>
          </>
        ) : null
    },
    {
      title: 'PDF',
      render: (text, row, index) => {
        return (
          <>
            <Button type={'link'} onClick={() => verPdf(row)}>
              <FilePdfOutlined />
            </Button>
          </>
        );
      }
    }
  ];

  const verPdf = async (val) => {
    message.info('Generando informe...');
    const response = await saludProvider.obtenerFichaPorId(val.id);
    setficha(response.data);
    setMostrarPdf(true);
  };

  const [mostrarPdf, setMostrarPdf] = useState(false);

  const vistaRapida = async (val) => {
    console.info(val.id);
    const response: any = await saludProvider.obtenerFichaPorId(val.id);
    if (response.succeeded) mostrarInformacion(response.data);
  };

  const abrirFicha = (val) => {
    navegarAFicha(val);
  };

  const obtenerFichas = async () => {
    setcargando(true);
    const paginacion = {
      PageNumber: current * pageSize,
      PageSize: pageSize,
      Filter: filtro
    };
    const response: any = await api.obtenerFichasPaginado(paginacion);
    if (response) setData(response);
    setcargando(false);
  };

  useEffect(() => {
    obtenerFichas();
  }, [current]);

  const callback = (val) => {
    val.length > 0 ? setfiltroactivo('1') : setfiltroactivo('0');
  };

  const filtrar = async (val) => {
    setcargando(true);
    const _filtro = {
      Nombre: val.usuario,
      FechaIni: val.fechas ? val.fechas[0] : undefined,
      FechaFin: val.fechas ? val.fechas[1] : undefined
    };
    setfiltro(_filtro);
    const paginacion = {
      PageNumber: current * pageSize,
      PageSize: pageSize,
      Filter: _filtro
    };
    const response: any = await api.obtenerFichasPaginado(paginacion);
    if (response) setData(response);
    setfiltroactivo('0');
    setcargando(false);
  };
  const layoutFiltro = {
    labelCol: {
      span: 8
    },
    wrapperCol: {
      span: 16
    }
  };
  const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 30
    }
  };

  const onExport = async () => {
    setexportando(true);
    const res = await reportesProvider.exportarFichas();
    saveAs(res.data, `Fichas-${moment(new Date()).format('L')}.xlsx`);
    setexportando(false);
  };

  return (
    <>
      <Modal
        title={'Ficha'}
        centered
        visible={mostrarPdf}
        onOk={() => setMostrarPdf(false)}
        onCancel={() => setMostrarPdf(false)}
        width={1000}
      >
        <Row>
          <Col>
            {/*<PDFDownloadLink document={<FichaPreview {...ficha} />} fileName='ficha.pdf'>*/}
            {/*  {({ blob, url, loading, error }) => (loading ? 'Descargando...' : 'Descargar')}*/}
            {/*</PDFDownloadLink>*/}
          </Col>
        </Row>
        {/*<PDFViewer style={{ width: '100%', height: '400px' }}>*/}
        {/*  {<FichaPreview {...ficha} />}*/}
        {/*</PDFViewer>*/}
      </Modal>
      <Collapse
        activeKey={filtroActivo}
        onChange={callback}
        expandIconPosition={'right'}
        expandIcon={() => (cargando ? <SyncOutlined spin /> : null)}
      >
        <Panel header='Filtros:' key='1'>
          <Form name='time_related_controls' onFinish={filtrar} {...layoutFiltro}>
            <Form.Item name='usuario' label={'Apellidos o Nombres'}>
              <Input placeholder={'Apellidos o Nombres'} />
            </Form.Item>
            <Form.Item name='fechas' label='Fechas'>
              <RangePicker
                format={['DD/MM/YYYY']}
                locale={locale}
                placeholder={['Desde', 'Hasta']}
              />
            </Form.Item>
            <Form.Item {...tailLayout}>
              <Button type='primary' icon={<SearchOutlined />} loading={cargando} htmlType='submit'>
                Filtrar
              </Button>
              <Button
                htmlType='button'
                loading={exportando}
                onClick={onExport}
                icon={<DownloadOutlined />}
              >
                Excel
              </Button>
            </Form.Item>
          </Form>
        </Panel>
      </Collapse>
      <Divider />
      <Table
        locale={{ emptyText: 'No existen registros' }}
        pagination={false}
        columns={columns}
        dataSource={data.data}
        bordered
      />
      <br />
      <Row justify={'center'}>
        <Col>
          <PaginacionPersonalizada
            total={data.totalRecords}
            current={current}
            onChange={setCurrent}
          />
        </Col>
      </Row>
    </>
  );
};

export default TablaCovid19;
